
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RolesStatsMulti"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"users"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"referenceDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"users"},"value":{"kind":"Variable","name":{"kind":"Name","value":"users"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stats"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"referenceDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"referenceDate"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monthContractMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthPlannedMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"monthOverTimeMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"balancingPeriodContractMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"balancingPeriodPlannedMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yearVacationMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yearVacationRemainingMinutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yearVacationDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yearVacationRemainingDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"yearUnavailabilities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categoryId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minutes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minutesRemaining"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minutesMaximum"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"days"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daysRemaining"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"daysMaximum"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":694}};
    doc.loc.source = {"body":"query RolesStatsMulti(\n  $workspaceId: ID!\n  $users: [ID!]\n  $referenceDate: Datetime\n) {\n  workspace(id: $workspaceId) {\n    roles(users: $users) {\n      stats(referenceDate: $referenceDate) {\n        monthContractMinutes\n        monthPlannedMinutes\n        monthOverTimeMinutes\n        balancingPeriodContractMinutes\n        balancingPeriodPlannedMinutes\n        yearVacationMinutes\n        yearVacationRemainingMinutes\n        yearVacationDays\n        yearVacationRemainingDays\n        yearUnavailabilities {\n          categoryId\n          minutes\n          minutesRemaining\n          minutesMaximum\n          days\n          daysRemaining\n          daysMaximum\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["RolesStatsMulti"] = oneQuery(doc, "RolesStatsMulti");
        
